<template>
	<div>
		<el-dialog
			:visible.sync="showuserwin"
			:title="userid == '' ? '新增用户' : '修改用户'"
			width="500px"
			:close-on-click-modal="false"
			lock-scroll
			:modal-append-to-body="false"
			:show-close="false"
		>
			<div class="userinfo">
				<el-form :inline="true" class="demo-form-inline" size="small">
					<el-form-item label-width="100px" :label="item.showname" v-for="item in columns" :key="item.colname">
						<el-input
							v-model="userinfo[item.colname]"
							:style="{ width: `${item.coltdwidth}px` }"
							v-if="item.controltype == 'text' && item.colname == 'u_account'"
							:disabled="edituserid != ''"
							:placeholder="'请输入' + item.showname"
							@input="changeinput"
						></el-input>
						<el-input
							v-model="userinfo[item.colname]"
							:style="{ width: `${item.coltdwidth}px` }"
							v-if="item.controltype == 'text' && item.colname != 'u_account'"
							:placeholder="'请输入' + item.showname"
							@input="changeinput"
						></el-input>

						<el-input
							v-model="userinfo[item.colname]"
							:style="{ width: `${item.coltdwidth}px` }"
							v-if="item.controltype == 'password'"
							:placeholder="'请输入' + item.showname"
							:disabled="userid != ''"
							show-password
							@input="changeinput"
						></el-input>
						<el-link v-if="userid != '' && item.controltype == 'password'" @click="userid = ''" type="primary" style="margin-left:10px" :underline="false">重置密码</el-link>
						<el-input
							type="textarea"
							v-model="userinfo[item.colname]"
							:style="{ width: `${item.coltdwidth}px` }"
							v-if="item.controltype == 'textarea'"
							:placeholder="'请输入' + item.showname"
							@input="changeinput"
						></el-input>
						<el-select
							v-model="userinfo[item.colname]"
							:style="{ width: `${item.coltdwidth}px` }"
							v-if="item.controltype == 'select'"
							@change="changeinput"
							:placeholder="item.coldefault"
						>
							<el-option v-for="p in item.colsource" :key="p.value" :label="p.label" :value="p.value"></el-option>
						</el-select>
						<!-- <el-link v-if="item.colname=='r_name'&&edituserid==''" type="primary" @click.native="handle('addrole')" style="margin-left:10px">添加新角色</el-link> -->
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-row>
						<el-col :span="6" style="color:transparent">1</el-col>
						<el-col :span="7">
							<el-button type="success" size="mini" @click="saveuser" :disabled="btndisabled">保存</el-button>
							<el-button size="mini" @click="showuserwin = false">取消</el-button>
						</el-col>
					</el-row>
				</span>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: {},
	data() {
		return {
			columns: [
				{
					colname: 'u_account',
					showname: '用户账号',
					isnull: false,
					controltype: 'text',
					coltype: 'text',
					coltdwidth: 200,
					colindex: 1,
					coldefault: '1001',
					colformat: '去特殊符号',
					linkvalue: '',
					linkcol: []
				},
				{
					colname: 'u_name',
					showname: '用户姓名',
					isnull: false,
					controltype: 'text',
					coltype: 'text',
					coltdwidth: 200,
					colindex: 2,
					coldefault: '',
					colformat: '',
					linkvalue: '',
					linkcol: []
				},
				{
					colname: 'u_password',
					showname: '登录密码',
					isnull: false,
					controltype: 'password',
					coltype: 'text',
					coltdwidth: 200,
					colindex: 3,
					coldefault: '',
					colformat: '',
					linkvalue: '',
					linkcol: []
				},
				{
					colname: 'u_company',
					showname: '所属公司',
					isnull: false,
					controltype: 'text',
					coltype: 'text',
					coltdwidth: 200,
					colindex: 4,
					coldefault: '',
					colformat: '',
					linkvalue: '',
					linkcol: []
				}
				// ,
				// {
				// 	colname: 'r_name',
				// 	showname: '用户角色',
				// 	isnull: false,
				// 	controltype: 'select',
				// 	coltype: 'text',
				// 	coltdwidth: 200,
				// 	colindex: 5,
				// 	coldefault: '',
				// 	colformat: '',
				// 	linkvalue: '',
				// 	linkcol: [],
				// 	colsource: [],
				// 	groupcoltrol: [
				// 		{
				// 			colname: '',
				// 			showname: '添加新角色',
				// 			isnull: false,
				// 			controltype: 'link',
				// 			coltype: '',
				// 			coltdwidth: 0,
				// 			colindex: 1,
				// 			coldefault: '',
				// 			colformat: '',
				// 			colevent: 'click',
				// 			colfun: 'addrole',
				// 			linkvalue: '',
				// 			linkcol: []
				// 		}
				// 	]
				// }
			],
			userid: '',
			edituserid: '',
			rolelist: [],
			showuserwin: false,
			userinfo: {
				u_account:'',
				u_name:'',
				u_password:'',
				r_name:''
			},
			groupname: '',
			btndisabled: true
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/user/userinfo.scss');
		});
	},
	methods: {
		//初始化
		init(param) {
			//debugger
			this.userid = param.userid;
			this.edituserid = param.userid;
			if (this.edituserid != '') {
				this.userinfo = param.userinfo;
			}
			if (param.groupname != undefined) this.groupname = param.groupname;
			this.showuserwin = true;
		},
		handle(event) {
			this.$emit('footerhandle', {
				winname: this.winname,
				funname: event
			});
		},
		changeinput() {
			if (this.userinfo.u_password == undefined) {
				this.userinfo.u_password = '';
			}
			if (this.userinfo.u_name != '' && this.userinfo.u_company != '' && this.userinfo.u_password != '') {
				this.btndisabled = false;
			} else {
				this.btndisabled = true;
			}
		},
		//保存用户信息
		saveuser() {
			if (this.userkey == '') {
				if (this.$tool.formatinput(this.userinfo.u_account) == '') {
					this.$tool.message('请输入账号', 0);
					return false;
				}
				if (this.$tool.formatinput(this.userinfo.u_password) == '') {
					this.$tool.message('请输入密码', 0);
					return false;
				}
			} else {
				if (this.userinfo.u_password != undefined) {
					if (this.$tool.formatinput(this.userinfo.u_password) == '') {
						this.$tool.message('请输入密码', 0);
						return false;
					}
				}
			}
			if (this.$tool.formatinput(this.userinfo.u_name) == '') {
				this.$tool.message('请输入姓名', 0);
				return false;
			}
			if (this.$tool.formatinput(this.userinfo.u_company) == '') {
				this.$tool.message('请输入所属公司', 0);
				return false;
			}
			if (this.userinfo.u_password == undefined) {
				this.userinfo.u_password = '';
			}
			var that = this;
			this.$tool.loading('正在保存', 'userinfo');
			this.$apipost.post.SaveUserInfo({ userinfo: JSON.stringify(this.userinfo) }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('保存成功', 1);
					that.showuserwin = false;
					that.$parent.GetUserList(false, true);
				} else {
					this.$message.error(res.message);
				}
			});
		}
	}
};
</script>
